<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader" *ngIf="document"></app-content-header>
    <div class="card pt-1 col-12" *ngIf="document">
      <div class="row justify-content-between px-1" [ngClass.sm]="'align-items-center'">
        <div>
          <label class="font-small-4 font-weight-bold">{{ "CATEGORY" | translate }}:</label>
          <p class="font-medium-1">{{ document.document_data.category }}</p>
        </div>
        <div class="ml-2">
          <label class="font-small-4 font-weight-bold">{{ "DATE" | translate }}:</label>
          <p class="font-medium-1">{{ _utilService.formatDate(document.document_data.send_date, "DD/MM/YYYY HH:mm") }}</p>
        </div>
        <div [ngClass.sm]="'mb-1'" [ngClass.xl]="'ml-2'">
          <label class="font-small-4 font-weight-bold">{{ "REQUIRED_SIGNATURE" | translate }}:</label>
          <span class="text-success ml-025" [data-feather]="'check'" size="20" *ngIf="document.document_data.require_signature"></span>
          <span class="text-danger ml-025" [data-feather]="'x'" size="20" *ngIf="!document.document_data.require_signature"></span>
          <div>
            <label class="font-small-4 font-weight-bold">{{ "REQUIRED_ACCEPTION" | translate }}:</label>
            <span class="text-success ml-025" [data-feather]="'check'" size="20" *ngIf="document.document_data.require_acception"></span>
            <span class="text-danger ml-025" [data-feather]="'x'" size="20" *ngIf="!document.document_data.require_acception"></span>
          </div>
        </div>
        <div>
          <span
            class="badge badge-pill badge-light-{{ _documentService.document_status_signature_sended[document.document_user_data.status].color }} mr-1"
            *ngIf="document.document_user_data.signed == 1 && document.document_data.require_signature == 1"
          >
            {{ _documentService.document_status_signature_sended[document.document_user_data.status].label | translate }}
          </span>
          <span
            class="badge badge-pill badge-light-{{ _utilService.dateIsInThreeDays(document.document_data.end_date) ? 'danger' : 'warning' }} mr-1"
            *ngIf="document.document_data.end_date && document.document_user_data.signed == 0 && document.document_data.require_signature == 1"
          >
            {{ "NOT_SIGNED" | translate }} {{ "WITHIN" | translate }} {{ _utilService.formatDate(document.document_data.end_date, "DD/MM/YY") }}
          </span>
          <span class="badge badge-pill badge-light-danger mr-1" *ngIf="!document.document_data.end_date && document.document_user_data.signed == 0 && document.document_data.require_signature == 1">
            {{ "NOT_SIGNED" | translate }}
          </span>
          <span class="badge badge-pill badge-light-success mr-1" *ngIf="document.document_user_data.having_read == 1 && document.document_data.require_acception == 1">{{ "VIEWED" | translate }} </span>
          <span
            class="badge badge-pill badge-light-{{ _utilService.dateIsInThreeDays(document.document_data.end_date) ? 'danger' : 'warning' }} mr-1"
            *ngIf="document.document_data.end_date && document.document_user_data.having_read == 0 && document.document_data.require_acception == 1"
            >{{ "NOT_VIEWED" | translate }} {{ "WITHIN" | translate }} {{ _utilService.formatDate(document.document_data.end_date, "DD/MM/YY") }}
          </span>
          <span class="badge badge-pill badge-light-danger mr-1" *ngIf="!document.document_data.end_date && document.document_user_data.having_read == 0 && document.document_data.require_acception == 1"
            >{{ "NOT_VIEWED" | translate }}
          </span>
        </div>
        <div class="col-12 pl-0" *ngIf="!!document.document_data.description">
          <label class="font-small-4 font-weight-bold">{{ "DESCRIPTION" | translate }}:</label>
          <p class="font-medium-1">{{ document.document_data.description }}</p>
        </div>
        <div class="col-12 pl-0" *ngIf="document.document_user_data.status_note && document.document_user_data.status_note.length > 0">
          <label class="font-small-4 font-weight-bold">{{ "NOTE" | translate }}:</label>
          <p class="font-medium-1">{{ document.document_user_data.status_note }}</p>
        </div>
        <div>
          <button class="btn btn-outline-danger mb-1 mr-1" (click)="deleteDocument()" *ngIf="_authenticationService.hasCapability('delete_document')">{{ "DELETE" | translate }}</button>
          <button class="btn btn-outline-primary mb-1" (click)="download(document.path_file)">{{ "DOWNLOAD" | translate }}</button>
        </div>
      </div>
    </div>

    <iframe [src]="document.file_url" frameborder="0" *ngIf="document && document.file_url"></iframe>

    <div
      class="d-flex card-footer bg-white justify-content-end align-items-center mb-075"
      *ngIf="document && document.document_user_data.signed == 1 && document.document_user_data.status !== 1 && currentUser.hash !== this.user_hash"
    >
      <div>
        <button class="btn btn-outline-primary" (click)="openModal(noteModal)">{{ "REJECT" | translate }}</button>
        <button class="btn btn-primary ml-1" (click)="acceptDocument()">{{ "ACCEPT" | translate }}</button>
      </div>
    </div>
  </div>
</div>

<!-- note rejected document Modal -->
<ng-template #noteModal let-modal>
  <div>
    <div class="modal-header">
      <div></div>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "INSERT_MOTIVATION_NOTE" | translate }}</h3>
      <div class="form-group mb-1">
        <label for="noteAborted">{{ "MOTIVATION" | translate }}<sup class="text-danger">*</sup></label>
        <textarea [(ngModel)]="rejectedNote" class="form-control" name="noteAborted" id="noteAborted" cols="45" rows="3"></textarea>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button [disabled]="rejectedNote.length < 5" (click)="rejectDocument()" class="btn btn-primary w-150" rippleEffect>{{ "SEND" | translate }}/{{ "ERRORS.INSERT" | translate }}</button>
    </div>
  </div>
</ng-template>
<!-- / note rejected document Modal -->
